const NAME = 'name';
const ZIP_CODE = 'zip_code';
const CITY = 'city';
const PHONE_NUMBER = 'phone_number';
const EMAIL = 'email';
const BRANCH_ID = 'external_id';
const ADDRESS = 'address';
const ADDRESS_1 = 'address_1';
const ADDRESS_2 = 'address_2';
const CreateBranchPayloadData = {
    address: '',
    post_code: '',
    name: '',
    room: '',
    email: '',
    phone: '',
    kind: '',
};
export { NAME, ADDRESS, ADDRESS_1, ADDRESS_2, ZIP_CODE, CITY, PHONE_NUMBER, EMAIL, BRANCH_ID, CreateBranchPayloadData, };
